/*
 * PendoHelper - Helper functions for Pendo
 */

/**
 * @returns {Boolean}
 */
export function isPendoReady() {
  return window.pendo?.isReady && window.pendo?.isReady();
}

const maxRetries = 10;
const retryTimeInMilliseconds = 500;

/**
 *
 * @param {string} eventName pendo event key
 * @param {Record<string, string | number | string[]} metadata pendo metadata object
 * @param {number} retryCount initial retry count
 * @param {boolean} skipTimeout skip the first timeout and send instantly
 */
export function trackPendoEvent(
  eventName,
  metadata = {},
  retryCount = 0,
  skipTimeout = false,
) {
  if (isPendoReady()) {
    window.pendo.track(eventName, metadata);
    return;
  }
  if (retryCount >= maxRetries) {
    return;
  }
  setTimeout(
    () => {
      trackPendoEvent(eventName, metadata, retryCount + 1);
    },
    skipTimeout ? 0 : retryTimeInMilliseconds,
  );
}
